export default __webpack_public_path__ + "static/media/imgKip2.f4106ba1.png";